//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AssetsMaintainDrawer from "./modules/AssetsMaintainDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList } from '@/api/api';
export default {
  name: 'AssetsMaintainList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    AssetsMaintainDrawer: AssetsMaintainDrawer
  },
  data: function data() {
    return {
      pagePath: '/ea/assets/maintain',
      pageTitle: '设备保养',
      addDisabled: false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_code',
        title: '设备资产编号',
        align: 'center'
      }, {
        dataIndex: 'productName',
        colName: 'asset_id',
        title: '设备资产名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '保养编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'maintainDate',
        colName: 'maintainDate',
        title: '保养日期',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'description',
        colName: 'description',
        title: '保养内容',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '保养类别',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'fee',
        colName: 'fee',
        title: '保养费用(元)',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '责任人',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      userTree: [] //人员信息

    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  created: function created() {
    this.loadTreeList();
  },
  computed: {},
  methods: {
    onDateFaultDate: function onDateFaultDate(value, dateArray) {
      this.queryParam.maintainDateStart = dateArray[0];
      this.queryParam.maintainDateEnd = dateArray[1];
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    }
  }
};